export interface Props {
  children?: JSX.Element | JSX.Element[];
}

const Tree = (props: Props) => {
  return <div className="slds-tree_container">{props.children}</div>;
};

export default Tree;
